import * as React from 'react';
import { ClassSelectItem } from 'vet-bones/utils/queryBuilder';
import { SelectItem } from 'vet-bones/utils/select';

import { useGenerateNewIri } from 'src/containers/ProjectDiagram/hooks/entityDrawer/useGenerateNewIri';
import { generateModelConceptIri } from 'src/containers/ProjectDiagram/utils/generateProjectIri';
import { projectSelector } from 'src/selectors/project';
import { getProjectTargetModel } from 'src/utils/getProjectTargetModel';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useCreateModelConceptClassFromQuery = (
  existingIris?: Set<string>
) => {
  const { projectId } = useRouterParams();
  const project = useReduxSelector(projectSelector(projectId));

  const generateNewIri = useGenerateNewIri();

  return React.useCallback(
    (query: string): SelectItem => {
      const text = query.trim();

      if (!project) {
        return { text, value: '', isNewlyCreated: true };
      }

      const initialValue = generateModelConceptIri(
        getProjectTargetModel(project),
        text
      );
      const value = generateNewIri(initialValue, existingIris);

      return {
        text,
        value,
        isNewlyCreated: true,
      };
    },
    [existingIris, generateNewIri, project]
  );
};

export const useCreateQueryBuilderClassFromQuery = (
  existingIris?: Set<string>
) => {
  const { projectId } = useRouterParams();
  const project = useReduxSelector(projectSelector(projectId));

  const generateNewIri = useGenerateNewIri();

  return React.useCallback(
    (query: string): ClassSelectItem => {
      const text = query.trim();

      if (!project) {
        return { colorId: '', text, value: '', isNewlyCreated: true };
      }

      const initialValue = generateModelConceptIri(
        getProjectTargetModel(project),
        text
      );
      const value = generateNewIri(initialValue, existingIris);

      return {
        colorId: 'sd-qb-black',
        text,
        value,
        isNewlyCreated: true,
      };
    },
    [existingIris, generateNewIri, project]
  );
};
